import Elemento from './Elemento.js';

export default class Valor extends Elemento {
  constructor() {
    super();
    this.coleccionesCompatible = null;
    this.texturasCompatible = null;
    this.seleccion = new Object();
    this.condicion = true;
    this.miniature = new String();
    this.filtros = new Object();
    this.resolveCondicion = function () {
      const seleccion = this.seleccion;
      return eval(this.condicion);
    };
  }
}
